import CalendarService from '../services/calendar.service';

const calendars = {
  namespaced: true,

  state: {},

  mutations: {},

  actions: {
    get(_, id) {
      return CalendarService.get(id);
    },
    getBySchedule(_, id) {
      return CalendarService.getBySchedule(id);
    },
    getDates(_, { id, date, type }) {
      return CalendarService.getDates(id, date, type);
    },
    getTimes(_, { id, date, type }) {
      return CalendarService.getTimes(id, date, type);
    },
    search(_, query) {
      return CalendarService.search(query);
    },
    schedule(_, {
      calendarId, scheduleId, patientId, cpf, covenantId, specialityId, particular, coupon, 
      serviceChannelId, serviceChannelUrl
    }) {
      return CalendarService.schedule(calendarId, scheduleId, patientId, cpf, covenantId, 
        specialityId, particular, coupon, serviceChannelId, serviceChannelUrl);
    },
    confirmSchedulePayment(_, { calendarId, scheduleId, paymentId }) {
      return CalendarService.confirmSchedulePayment(calendarId, scheduleId, paymentId);
    },
    getCovenants(_, id) {
      return CalendarService.getCovenants(id);
    },
  },

  getters: {},
};

export default calendars;
